import { useState, FormEvent, useEffect } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import CloseIcon from "@mui/icons-material/Close";
import AddModeratorIcon from "@mui/icons-material/AddModerator";
import { Container, Dialog, Stack, TextField } from "@mui/material";

import conf from "../../conf";
import Spinner from "../utils/Spinner";
import SectionHeader from "../utils/SectionHeader";
import { SelectAlgorithm, SelectProject } from "./Utils";
import { KeyGenAlgorithm, useProxyKeyRequest } from "../../hooks/proxy/keys";

const RequestView = (props: any) => {
  const { open, onClose } = props;

  const [algorithm, setAlgorithm] = useState<KeyGenAlgorithm | "">("");
  const [projectId, setProjectId] = useState<string>("");
  const [description, setDescription] = useState<string>("");

  const create = useProxyKeyRequest();

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    create.mutate({ projectId, algorithm, description });
  };

  const resetForm = () => {
    setProjectId("");
    setAlgorithm("");
    setDescription("");
  };

  useEffect(() => {
    if (create.isSuccess) {
      resetForm();
      onClose();
    }
  }, [create.isSuccess]);

  return (
    <Dialog maxWidth="md" fullWidth open={open} onClose={onClose}>
      <Container component="main" sx={conf.STYLE.DIALOG}>
        <SectionHeader
          key="key-request"
          title="Request"
          icon={<AddModeratorIcon />}
          buttons={[
            <Button
              key={"key-request-reset"}
              size="small"
              color="inherit"
              onClick={resetForm}
            >
              Reset
            </Button>,

            <Button
              key={"key-request-close"}
              size="small"
              color="inherit"
              onClick={onClose}
            >
              <CloseIcon />
            </Button>,
          ]}
        />

        <Box component="form" noValidate onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <SelectProject
                value={projectId}
                required={true}
                onChange={setProjectId}
                returnValue="id"
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <SelectAlgorithm
                label="Type"
                value={algorithm}
                onChange={setAlgorithm}
                algorithms={conf.ALGORITHMS.GENERATE}
              />
            </Grid>
          </Grid>

          <Grid item xs={12} sx={{ mt: 2 }}>
            <TextField
              fullWidth
              id="key-description"
              name="key-description"
              label="Description"
              value={description}
              onChange={(e: any) => setDescription(e.target.value)}
            />
          </Grid>

          <Stack direction="row" justifyContent="flex-end">
            <Button
              type="submit"
              variant="contained"
              disabled={!algorithm || !projectId}
              sx={{ mt: 2 }}
            >
              {create.isPending ? <Spinner sx={{ mx: 2.5 }} /> : "Submit"}
            </Button>
          </Stack>
        </Box>
      </Container>
    </Dialog>
  );
};

const Request = ({ disabled = false }: { disabled?: boolean }) => {
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <div>
      <Button
        color="secondary"
        variant="contained"
        disabled={disabled}
        onClick={handleOpen}
        startIcon={<AddModeratorIcon />}
      >
        Request
      </Button>

      <RequestView open={open} onClose={handleClose} />
    </div>
  );
};

export default Request;
